<template>
  <div class="content">
    <!-- 封面图 -->
    <div
      class="top-banner"
      :style="{
        'background-image': 'url(' + $baseUrl + game1.cover_pc + ')',
      }"
    ></div>
   <!--
    <div class="winWrap">
      <div class="sec1-title">
        <h3>
          <span>竞<div class="text-under-line"><div class="under-line"></div>赛获</div>奖</span>
        </h3>
      </div>
      <div class="winImgWrap">
        <template v-for="item in 3" >
          <img :key="item" :src="require('../assets/imgs/win'+item+'.jpg')" alt="">
        </template>
      </div>
    </div>
    -->
    <section class="sec1">
      <div class="sec1-title">
        <h3>
          <span>国<div class="text-under-line"><div class="under-line"></div>际赛</div>事</span>
        </h3>
      </div>
      <div class="content1">
        <div class="content1-text">
          <p v-html="game2.content"></p>
        </div>
        <img :src="$baseUrl + game2.cover_pc" />
      </div>
    </section>
    <section class="sec2">
      <div class="swiper-container swp1">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide swp1-item"
            v-for="(item, index) in game3"
            :key="index"
          >
            <div class="slide">
              <h5 :style={color:item.color}>
                <span class="game-num">0{{ index + 1 }}</span
                >{{ item.title }}
              </h5>
              <p v-html="item.desc"></p>
              <img :src="$baseUrl + item.imgUrl" />
              <div class="game-des">
                <p><span>主办单位: </span>{{ item.organizer }}</p>
                <p><span>竞赛时间: </span>{{ item.ompetition_time }}</p>
                <p><span>申报要求: </span>{{ item.requirement }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="swp1-prev"><img src="../assets/imgs/game8.png" /></div>
      <div class="swp1-next"><img src="../assets/imgs/game9.png" /></div>
    </section>
  </div>
</template>
<script>
import $ from "jquery";
import { getPage, getGames } from "@/api/api.js";
import Swiper from "swiper/dist/js/swiper.js";
export default {
  data() {
    return {
      //封面图
      game1: {},
      //国际赛事
      game2: {},
      //比赛
      game3: [],
    };
  },
  created() {
    //查询该页面内容
    this.fetchData();
  },
  methods: {
    //查询页面模块
    fetchData() {
      getPage({ c_tid: 5 }).then((res) => {
        this.game1 = res.data.st_28[0]; //封面图
        this.game2 = res.data.st_30[0]; //国际赛事
      });
      getGames({ type: 1 }).then((res) => {
        this.game3 = res.data; //赛事
        //初始化页面动画
        this.$nextTick(() => {
          this.init();
        });
      });
    },
    //初始化国际赛事轮播图
    init() {
      var mySwiper = new Swiper(".swp1", {
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 12,
        centeredSlides: true,
        navigation: {
          nextEl: ".swp1-next",
          prevEl: ".swp1-prev",
        },
      });
    },
    chooseItem(n) {
      this.current = n;
    },
  },
  updated() {
    $("p").find("span").css("color", "rgba(153, 153, 153, 1)");
    $(".game-des").find("span").css({ color: "#313131", "foot-weight": "600" });
  },
};
</script>
<style scoped>
@import "../assets/css/common.css";
.top-banner {
  width: 100%;
  height: 500px;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.winWrap{
  margin-top: 83px;
}

.winImgWrap img{
  width: 100%;
  display: block;
}
.sec1 {
  margin: 53px 0 67px;
}
.sec1-title {
  text-align: center;
  margin: 0 0 64px;
}
.sec1-title > h3 {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(26, 26, 26, 1);
  margin: 0;
}
.text-under-line {
  display: inline-block;
  position: relative;
}
.under-line {
  position: absolute;
  width: 80%;
  height: 5px;
  border-radius: 5px;
  bottom: -15px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #ff3500;
}
.content1 {
  margin: 0 auto;
  width: 1200px;
  height: 454px;
  border: 2px solid rgba(251, 155, 0, 0.3);
  box-shadow: 0px 0px 6px 0px rgba(251, 155, 0, 0.75);
  border-radius: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.content1-text {
  width: 460px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
  text-indent: 36px;
  line-height: 30px;
  text-align: justify;
}
.swp1 {
  width: 1200px;
  margin: 0 auto;
}
.swp1 .slide {
  padding: 23px;
}
.swp1 .swiper-slide {
  width: 548px;
  height: 620px;
  background: rgba(230, 230, 230, 0.3);
  text-align: center;
}
.swp1 .swiper-slide-prev,
.swp1 .swiper-slide-next {
  background: rgba(230, 230, 230, 0.3);
  opacity: 0.6;
}
.swp1 .swiper-slide-prev {
  transform: translateX(115px) scale(0.57, 0.65);
}
.swp1 .swiper-slide-next {
  transform: translateX(-115px) scale(0.57, 0.65);
}
.swp1 .slide > h5 {
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 26px;
  margin: 0;
}
.game-num {
  font-size: 53px;
  font-family: PingFang SC;
  font-weight: 200;
  color: rgba(230, 230, 230, 1);
  line-height: 67px;
}
.swp1 .slide > p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(128, 128, 128, 1);
  line-height: 26px;
  text-align: left;
  text-indent: 36px;
  margin: 10px 0;
}
.swp1 .slide > img {
  width: 498px;
  height: 278px;
  border-radius: 20px;
  margin: 10px 0;
}
.game-des {
  text-align: left;
  font-size: 16px;
  color: rgba(128, 128, 128, 1);
}
.game-des > span {
  font-weight: 600;
  color: #313131;
}
.fll > .game-des > p {
  margin: 8px 0;
}
.sec2 {
  padding: 50px 0 180px;
  position: relative;
}
.swp1-next,
.swp1-prev {
  position: absolute;
  top: 40%;
  outline: none;
  z-index: 1;
}
.swp1-next {
  right: 250px;
}
.swp1-prev {
  left: 250px;
}
.styl01 {
  color: #f00055;
}
.styl11 {
  color: #064ea3;
}
.styl21 {
  color: #91c50f;
}
.styl31 {
  color: #f00055;
}
.styl41 {
  color: #fb9b00;
}
</style>